import { Swiper } from './swiper-D_0i_b49.js';
import { A as A11y } from './a11y-Bc4Hy9nX.js';
import './utils-oQVxRlcV.js';

class QuickLinks extends HTMLElement {
  #swiper = this.querySelector('.swiper');

  connectedCallback() {
    this.initSwiper();
  }

  initSwiper() {
    new Swiper(this.#swiper, {
      modules: [A11y],
      slidesPerView: "auto",
      spaceBetween: 8,
    });
  }
}

customElements.define('quick-links', QuickLinks);
